import { Modal, Result } from "antd";
import { ExclamationCircleOutlined } from "@ant-design/icons";
import { useNavigate } from "react-router-dom";

export const DuplicatePlateModal = ({
    isModalOpen,
    setModal,
    modal,
    isModalForm,
}) => {
    const navigate = useNavigate();
    const errorItems = modal?.filter((item) => item.status === 400) || [];

    return (
        <Modal
            title={null}
            open={isModalOpen}
            onCancel={() => {
                setModal(null);
                !isModalForm && navigate(-1);
            }}
            footer={null}
            width={650}
            centered
        >
            <Result
                status="error"
                icon={<ExclamationCircleOutlined />}
                title="Duplicate Virtual QR/NFC Codes Detected"
                subTitle={
                    <div className="text-gray-600">
                        {errorItems.length > 0 && (
                            <div className="space-y-2">
                                <div className="text-sm mb-3">
                                    The following Virtual QR/NFC Codes are duplicates:
                                </div>
                                <div className="gap-2 flex items-center flex-wrap justify-center">
                                    {errorItems.map((item, index) => (
                                        <div
                                            key={index}
                                            className="bg-red-50 border border-red-200 rounded px-3 pb-0.5"
                                        >
                                            <code className="text-red-700 text-[12px] font-medium">
                                                {item.code}
                                            </code>
                                        </div>
                                    ))}
                                </div>
                            </div>
                        )}
                    </div>
                }
            />
        </Modal>
    );
};